exports.burn = {
  burnFlame: {
    code: 'burnFlame',
    display: 'Flame',
    system: 'bcm',
  },
  burnContact: {
    code: 'burnContact',
    display: 'Contact',
    system: 'bcm',
  },
  burnRadiation: {
    code: 'burnRadiation',
    display: 'Radiation',
    system: 'bcm',
  },
  burnSun: {
    code: 'burnSun',
    display: 'Sunburn',
    system: 'bcm',
  },
  burnScald: {
    code: 'burnScald',
    display: 'Scald',
    system: 'bcm',
  },
  burnScaldOil: {
    code: 'burnScaldOil',
    display: 'Scald, Oil',
    system: 'bcm',
  },
  burnScaldWater: {
    code: 'burnScaldWater',
    display: 'Scald, Water',
    system: 'bcm',
  },
  burnScaldSteam: {
    code: 'burnScaldSteam',
    display: 'Scald, Steam',
    system: 'bcm',
  },
  burnChemical: {
    code: 'burnChemical',
    display: 'Chemical',
    system: 'bcm',
  },
  burnElectrical: {
    code: 'burnElectrical',
    display: 'Electrical',
    system: 'bcm',
  },
  burnElectricalHighVoltage: {
    code: 'burnElectricalHighVoltage',
    display: 'Electrical, High Voltage (≥1,000V)',
    system: 'bcm',
  },
  burnElectricalLowVoltage: {
    code: 'burnElectricalLowVoltage',
    display: 'Electrical, Low Voltage (<1,000V)',
    system: 'bcm',
  },
  burnInhalation: {
    code: 'burnInhalation',
    display: 'Inhalation',
    system: 'bcm',
  },
};